export default class Newsletter {
    namespace: string = 'newsletter';

    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            const newsletterContainerAll = document.querySelectorAll<HTMLElement>('.section-newsletter');

            if (newsletterContainerAll.length) {
                newsletterContainerAll.forEach($newsletter => {
                    this.init($newsletter);
                })
            }
        });
    }

    init($newsletter: HTMLElement) {
        // console.log()
        (<HTMLInputElement>$newsletter.querySelector('input[type=email]')).placeholder = <string>(<HTMLElement>$newsletter.querySelector('label')).textContent;
    }
}
